import cx from 'classnames';
import React from 'react';
import { getFillColorClass } from '../core/colors';
import Icon from '../Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Spinner = _ref => {
  let {
    color = 'navy',
    size = 18
  } = _ref;
  return ___EmotionJSX("span", {
    className: cx('dc-icon', 'dc-icon--spinner', "dc-icon--size-".concat(size), getFillColorClass(color))
  }, ___EmotionJSX(Icon, {
    extraClass: "dc-icon__svg",
    name: "spinner"
  }));
};
export default Spinner;